import { lazy } from "react";
import type { IntakeDraftProps } from "./IntakeDraft";
const IntakeDraft = lazy(() => import("./IntakeDraft").then(module => ({ default: module.IntakeDraft })));
import { setStudioView } from "../workspace/studio-views";

export function mountIntakeDraft(slot: HTMLElement, props: IntakeDraftProps) {
  setStudioView("intake-draft", "intake-draft", <IntakeDraft {...props} />);
}
